module.exports = __webpack_public_path__ + "static/media/25UNHCR2.0c3c26cf.jpg";